import { UiTheme } from '../../theme'

export default (theme: UiTheme) => ({
  base: {
    marginTop: 0,
    marginBottom: theme.settings.spacing.large,
    maxWidth: theme.settings.content.maxWidth,
  },

  variants: {
    regular: {
      color: theme.colors.text.normal,
    },
    dim: {
      color: theme.colors.text.dimmed,
    },
    white: {
      color: theme.colors.text.light,
    },
    inherit: {
      color: 'inherit',
    },
  },

  sizes: {
    regular: theme.typography.body,
    small: theme.typography.small,
  },

  bold: {
    fontWeight: theme.settings.typography.weights.semibold,
  },

  tight: {
    marginBottom: theme.settings.spacing.small,
  },

  flush: {
    marginBottom: 0,
  },

  flushLastChild: {
    ':last-child': {
      marginBottom: 0,
    },
  },

  wide: {
    maxWidth: 'none',
  },
})
